var render = function render(){var _vm=this,_c=_vm._self._c;return _c('emc-table-icon',{attrs:{"color":_vm.color,"icon":_vm.icon,"disabled":_vm.disabled,"loading":_vm.loading,"tool-tip":_vm.toolTip},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }